import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import OfferFormSubscription from "../OfferFormSubscription";
import { setActiveSection } from "../../redux/actions/dashboardActions";
import { fetchActiveSubscription } from "../../redux/actions/subscriptionOfferAction";
import { loadUserProfile } from "../../redux/actions/authActions";
import "./styles.css";
export default function SubscriptionOffersPrestataire() {
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showFormOfferSubscription, setShowFormOfferSubscription] = useState(false);
    const [offerToSubscribe, setOfferToSubscribe] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    const { user, token } = useSelector((state) => state.auth);
    const { prestataire } = useSelector((state) => state.profil);
    const [showVerificationModal, setShowVerificationModal] = useState(false);
    const [verificationStatus, setVerificationStatus] = useState(null);


    const dispatch = useDispatch();

    const refreshOffers = useCallback(() => {
        const url = `${apiUrl}/api/offers`;
        setLoading(true);

        return fetch(url, { method: "GET" })
            .then((res) => res.json())
            .then((data) => setOffers(data))
            .catch((err) => console.error("Erreur chargement des offres :", err))
            .finally(() => setLoading(false));
    }, [apiUrl]);

    useEffect(() => {
        refreshOffers();
    }, [refreshOffers]);

    const handleSubscribeClick = (offer) => {
        const status = prestataire?.validationProfil;

        if (status !== "verified") {
            setVerificationStatus(status);
            setShowVerificationModal(true);
            return;
        }

        // Profil validé → OK
        setOfferToSubscribe(offer);
        setShowFormOfferSubscription(true);
    };

    const handleSave = async (offerId, stripeId, type, paymentIntentId = null, nbCredits = 1) => {
        try {
            let body;

            if (type === "subscription") {
                body = {
                    offerId,
                    subscriptionId: stripeId,
                    paymentIntentId,
                    nbCredits,
                };
            } else {
                body = {
                    offerId,
                    paymentIntentId: stripeId,
                    nbCredits,
                };
            }

            const res = await fetch(`${apiUrl}/api/subscribe/success`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body),
            });

            const data = await res.json();
            if (data.error) {
                console.error("Erreur lors de l'enregistrement :", data.error);
            } else {
                console.log("Souscription enregistrée !", data);
            }
        } catch (err) {
            console.error("Erreur réseau :", err);
        }
    };



    return (
        <section className="secteur-section">
            <h2>Les offres INTERESEAUX</h2>


            {loading ? (
                <div className="loader">
                    <div className="spinner"></div>
                    Chargement des offres...
                </div>
            ) : offers.length === 0 ? (
                <p>Aucune offre disponible.</p>
            ) : (
                offers.map((offer) => (
                    <div key={offer.idOffer} className="offer-card">
                        <div className="offer-info">
                            <span className="offer-title">{offer.titleOffer}</span>
                            <span className="offer-desc">{offer.descriptionOffer}</span>
                            <span className="offer-price">
                                {offer.priceOfferTTC.toFixed(2)} € TTC
                            </span>
                        </div>
                        <button onClick={() => handleSubscribeClick(offer)}>{offer.isRecurring ? "SOUSCRIRE" : "ACHETER"}</button>
                    </div>
                ))
            )}

            {showFormOfferSubscription && (
                <OfferFormSubscription
                    offerToSubscribe={offerToSubscribe}
                    onClose={() => { setShowFormOfferSubscription(false); dispatch(setActiveSection("projets")); dispatch(fetchActiveSubscription(token)); dispatch(loadUserProfile(token)); }}
                    onCancel = {() => setShowFormOfferSubscription(false)}
                    onSave={handleSave}
                    apiUrl={apiUrl}
                    token={token}
                />
            )}

            {showVerificationModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        {verificationStatus === "pending" && (
                            <>
                                <h3>⏳ Validation en cours</h3>
                                <p>
                                    Vos documents ont bien été envoyés.<br />
                                    Notre équipe est en train de vérifier votre profil.
                                </p>
                                <button onClick={() => setShowVerificationModal(false)}>
                                    Fermer
                                </button>
                            </>
                        )}

                        {verificationStatus === "not_verified" && (
                            <>
                                <h3>🔒 Profil non vérifié</h3>
                                <p>
                                    Vous devez vérifier votre profil avant de souscrire à une offre.
                                </p>
                                <button
                                    onClick={() => {
                                        setShowVerificationModal(false);
                                        dispatch(setActiveSection("validerProfil"));
                                    }}
                                >
                                    Vérifier mon profil
                                </button>
                            </>
                        )}

                        {verificationStatus === "refused" && (
                            <>
                                <h3>❌ Profil refusé</h3>
                                <p>
                                    Votre profil a été refusé. Merci de corriger vos documents.
                                </p>
                                <button
                                    onClick={() => {
                                        setShowVerificationModal(false);
                                        dispatch(setActiveSection("validerProfil"));
                                    }}
                                >
                                    Mettre à jour mes documents
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}


        </section>
    );
}
